import * as React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";

interface IProps {
  heading: string;
  body: any;
}

import "./index.css";

const CardComponent: React.SFC<IProps> = ({ heading, body }) => {
  return (
    <Card>
      <CardHeader>{heading}</CardHeader>
      <CardBody>{body}</CardBody>
    </Card>
  );
};

export default CardComponent;



// WEBPACK FOOTER //
// ./src/Components/Card/index.tsx